"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSea16SupportedChains = void 0;
// https://github.com/ProjectOpenSea/seaport
var OpenSea16SupportedChains;
(function (OpenSea16SupportedChains) {
    OpenSea16SupportedChains[OpenSea16SupportedChains["ETHEREUM"] = 1] = "ETHEREUM";
    OpenSea16SupportedChains[OpenSea16SupportedChains["ETHEREUM_SEPOLIA"] = 11155111] = "ETHEREUM_SEPOLIA";
    OpenSea16SupportedChains[OpenSea16SupportedChains["POLYGON"] = 137] = "POLYGON";
    OpenSea16SupportedChains[OpenSea16SupportedChains["POLYGON_AMOY"] = 80002] = "POLYGON_AMOY";
    OpenSea16SupportedChains[OpenSea16SupportedChains["OPTIMISM"] = 10] = "OPTIMISM";
    OpenSea16SupportedChains[OpenSea16SupportedChains["OPTIMISM_SEPOLIA"] = 11155420] = "OPTIMISM_SEPOLIA";
    OpenSea16SupportedChains[OpenSea16SupportedChains["ARBITRUM"] = 42161] = "ARBITRUM";
    OpenSea16SupportedChains[OpenSea16SupportedChains["ARBITRUM_SEPOLIA"] = 421614] = "ARBITRUM_SEPOLIA";
    OpenSea16SupportedChains[OpenSea16SupportedChains["ARBITRUM_NOVA"] = 42170] = "ARBITRUM_NOVA";
    OpenSea16SupportedChains[OpenSea16SupportedChains["BASE"] = 8453] = "BASE";
    OpenSea16SupportedChains[OpenSea16SupportedChains["BASE_SEPOLIA"] = 84532] = "BASE_SEPOLIA";
    OpenSea16SupportedChains[OpenSea16SupportedChains["AVALANCHE"] = 43114] = "AVALANCHE";
    OpenSea16SupportedChains[OpenSea16SupportedChains["AVALANCHE_FUJI"] = 43113] = "AVALANCHE_FUJI";
    OpenSea16SupportedChains[OpenSea16SupportedChains["GNOSIS"] = 100] = "GNOSIS";
    OpenSea16SupportedChains[OpenSea16SupportedChains["GNOSIS_CHIADO"] = 10200] = "GNOSIS_CHIADO";
    OpenSea16SupportedChains[OpenSea16SupportedChains["BINANCE"] = 56] = "BINANCE";
    OpenSea16SupportedChains[OpenSea16SupportedChains["BINANCE_TEST"] = 97] = "BINANCE_TEST";
    OpenSea16SupportedChains[OpenSea16SupportedChains["KLAYTN"] = 8217] = "KLAYTN";
    OpenSea16SupportedChains[OpenSea16SupportedChains["KLAYTN_BAOBAB"] = 1001] = "KLAYTN_BAOBAB";
    OpenSea16SupportedChains[OpenSea16SupportedChains["MOONBEAM"] = 1284] = "MOONBEAM";
    OpenSea16SupportedChains[OpenSea16SupportedChains["MOONRIVER"] = 1285] = "MOONRIVER";
    OpenSea16SupportedChains[OpenSea16SupportedChains["CANTO"] = 7700] = "CANTO";
    OpenSea16SupportedChains[OpenSea16SupportedChains["FANTOM"] = 250] = "FANTOM";
    OpenSea16SupportedChains[OpenSea16SupportedChains["CELO"] = 42220] = "CELO";
    OpenSea16SupportedChains[OpenSea16SupportedChains["ZORA"] = 7777777] = "ZORA";
    OpenSea16SupportedChains[OpenSea16SupportedChains["ZORA_SEPOLIA"] = 999999999] = "ZORA_SEPOLIA";
})(OpenSea16SupportedChains || (exports.OpenSea16SupportedChains = OpenSea16SupportedChains = {}));
//# sourceMappingURL=supported.js.map